import { useUpdateUserMutation } from "../../api/api-hooks";
import { UserFormFromScratch } from "./userTypes";

const useUserItemUpdater = () => {
  const [editUser] = useUpdateUserMutation();
  return (item: UserFormFromScratch, id: number) => {
    return editUser({
      id: Number(id),
      updateUserDto: {
        name: item.name,
        phone: item.phone,
        address: item.address,
        email: item.email,
        companyId: item.company ? item.company.id : undefined,
        role: Number(item.role),
        id: Number(id),
      },
    });
  };
};
export default useUserItemUpdater;
